import styles from "../../styles/components/UI/Notification.module.css";
import React, { useEffect, useState } from 'react';

export const Notification = ({ message, type = "" }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 5000);

    return () => clearTimeout(timer); 
  }, [message, type]);

  const containerClass =
    type === "error"
      ? `${styles.container} ${styles.error}`
      : `${styles.container} ${styles.info}`;

  if (!isVisible) {
    return null; 
  }

  return (
    <div className={containerClass}>
      {message}
    </div>
  );
};